<template>
    <div>
        <b-field expanded>
            <template #label>
                Filters
                <b-tooltip type="is-dark" label="Add new filter">
                    <div class="pointer" @click="add">
                        <b-icon size="is-small" icon="plus-circle" type="is-success"></b-icon>
                    </div>
                </b-tooltip>
            </template>
        </b-field>
        <b-table narrowed bordered striped :data="filters" hoverable>
            <b-table-column label="English Title" v-slot="props">
                {{ props.row.name_en }}
            </b-table-column>
            <b-table-column label="Arabic Title" v-slot="props">
                {{ props.row.name_ar }}
            </b-table-column>
            <b-table-column label="Kurdish Title" v-slot="props">
                {{ props.row.name_ku }}
            </b-table-column>
            <b-table-column v-slot="props">
                <b-tooltip label="Edit">
                    <a class="pointer" @click="edit(props.row)">
                        <b-icon icon="file-document-edit-outline" type="is-primary" />
                    </a>
                </b-tooltip>
                <b-tooltip label="Remove" type="is-danger">
                    <a class="pointer" @click="showDelete(props.row.id)">
                        <b-icon icon="delete" type="is-danger" />
                    </a>
                </b-tooltip>
            </b-table-column>
        </b-table>
        <b-modal v-model="isModal" has-modal-card trap-focus :destroy-on-hide="false" aria-label="Modal" @close="form.reset()" can-cancel>
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ isEdit ? `Edit #${form.id}` : "New" }}</p>
                    <button type="button" class="delete" @click="isModal = false" />
                </header>
                <section class="modal-card-body">
                    <b-field label="English Title" :message="form.errors.get(`name_en`)" :type="{ 'is-danger': form.errors.has(`name_en`) }">
                        <b-input type="text" v-model="form.name_en" required />
                    </b-field>
                    <b-field label="Arabic Title" :message="form.errors.get(`name_ar`)" :type="{ 'is-danger': form.errors.has(`name_ar`) }">
                        <b-input type="text" v-model="form.name_ar" />
                    </b-field>
                    <b-field label="Kurdish Title" :message="form.errors.get(`name_ku`)" :type="{ 'is-danger': form.errors.has(`name_ku`) }">
                        <b-input type="text" v-model="form.name_ku" />
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <b-button label="Close" @click="isModal = false" />
                    <b-button label="Submit" type="is-primary" @click="submit" />
                </footer>
            </div>
        </b-modal>
        <b-modal v-model="isDeleteModal" has-modal-card trap-focus :destroy-on-hide="false" aria-label="Modal" can-cancel>
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Delete Filter</p>
                    <button type="button" class="delete" @click="isDeleteModal = false" />
                </header>
                <section class="modal-card-body">
                    <p>You need to specify another filter to move all posts related to this filter.</p>
                    <b-field label="Move to" expanded :message="delForm.errors.get(`move_to`)" :type="{ 'is-danger': delForm.errors.has(`move_to`) }">
                        <b-select v-model="delForm.move_to" expanded>
                            <option v-for="item in transferToList" :key="item.id" :value="item.id">{{ item.name_en }}</option>
                        </b-select>
                    </b-field>
                </section>
                <footer class="modal-card-foot">
                    <b-button label="Close" @click="isDeleteModal = false" />
                    <b-button label="Submit" type="is-primary" @click="remove" />
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
import vform from "../plugins/vForm";
export default {
    name: "FiltersComponent",
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        categoryId: {
            type: Number,
        },
    },
    data() {
        return {
            filters: [],
            form: new vform({
                id: 0,
                name_en: "",
                name_ar: "",
                name_ku: "",
                category_id: null,
            }),
            isModal: false,
            isEdit: false,
            isDeleteModal: false,
            deleteId: null,
            delForm: new vform({
                move_to: null,
            }),
        };
    },
    methods: {
        add() {
            this.isEdit = false;
            this.isModal = true;
            this.form.reset();
            this.form.category_id = this.categoryId;
        },
        edit(row) {
            this.isEdit = true;
            this.isModal = true;
            this.form.fill(row);
        },
        remove() {
            this.delForm.delete(`/categories/${this.categoryId}/filter/${this.deleteId}`).then(() => {
                const list = this.list.filter((i) => i.id !== this.deleteId);
                this.$emit("update:list", list);
                this.isDeleteModal = false;
                this.notify("Filter deleted successfully.", "is-success");
            });
        },
        showDelete(id) {
            this.isDeleteModal = true;
            this.deleteId = id;
        },
        submit() {
            if (!this.isEdit) {
                // Create
                this.form.post(`/categories/${this.categoryId}/filter`).then((item) => {
                    this.list.push(item.data);
                    this.isModal = false;
                    this.notify("Filter added successfully.", "is-success");
                });
            } else {
                // Edit
                this.form.post(`/categories/${this.categoryId}/filter/${this.form.id}`).then((item) => {
                    const list = this.list.filter((i) => i.id !== item.data.id);
                    list.push(item.data);
                    this.$emit("update:list", list);
                    this.isModal = false;
                    this.notify("Filter edited successfully.", "is-success");
                });
            }
        },
    },
    created() {
        this.filters = this.list;
    },
    watch: {
        list(newval) {
            this.filters = newval;
        },
    },
    computed: {
        transferToList() {
            if (!this.deleteId || this.deleteId === 0) {
                return [];
            }
            return this.list.filter((item) => item.id != this.deleteId);
        },
    },
};
</script>

<style>
</style>